import { Address } from '../../../models/utilities/address';
import { JsonProperty } from '../../../models/utilities/json-property';
import { LocalTimeRead } from '../../../models/utilities/local-time-read';
import { BackhaulStatus } from '../enums/backhaul-status';
import { DeliveryStatus } from '../enums/delivery-status';
import { ShipmentActionType } from "../enums/shipment-action-type";
import { OrderSummary } from "../shared/order-summary";

export class ShipmentAction {

    public type : ShipmentActionType = ShipmentActionType.Unknown;

    public id : number = 0;
        
    public index : number = 0;

    // TODO: Is this used anymore?  Or did index replace it?
    // public sequenceId : number = 0;
    
    public name : string = '';
    
    @JsonProperty({ toClass: Address })
    public address : Address = new Address();
            
    @JsonProperty({ toClass: LocalTimeRead })
    public actionTime : LocalTimeRead|undefined = undefined;

    // UI Helper Props
    public isSelected : boolean = false;
    public isPendingAdd : boolean = false;
    public tmpClientId : string = '';    
        
}

        export class TravelShipmentAction extends ShipmentAction {

            public travelTime : string = '';

            public distance : number = 0;

            public note : string = '';

            public unloadTime : string = '';

            constructor() {
                super();
            }

        }

        export class StartShipmentAction extends ShipmentAction {

            constructor() {
                super();
                this.type = ShipmentActionType.Origin;
            }

        }

        export class EndShipmentAction extends TravelShipmentAction {

            constructor() {
                super();
                this.type = ShipmentActionType.Destination;
            }
            
        }

        export class DeliveryShipmentAction extends TravelShipmentAction {
            
            public dealerId : string = '';

            public dealerName : string = '';
            
            public shipToAddressId : number = 0;

            public codAmount : number|undefined = 0.0;

            public status : DeliveryStatus = DeliveryStatus.Open;
                        
            public fixedFreightAmount : number|undefined = undefined;

            public parsNumber : string = '';

            public phoneNumber : string = '';           

            // Container Only
            public addOnCount : number|undefined = undefined;

            public addOnWeight : number|undefined = undefined;

            @JsonProperty({ toClass: OrderSummary, designType: 'array' })
            public orders : OrderSummary[] = [];
            
            // UI Helpers
            public isFixedFreight : boolean = false;
            public wasSeen : boolean = false;
            public orderGroupingId : number = 0;

            constructor() {
                super();
                this.type = ShipmentActionType.Delivery;
            }

        }

        export class BackhaulShipmentAction extends TravelShipmentAction {

            public vendorId : string = '';
            
            public vendorName : string = '';
            
            public shipToAddressId : number = 0;

            public status : BackhaulStatus = BackhaulStatus.Open;

            constructor() {
                super();
                this.type = ShipmentActionType.Backhaul;
            }
        }
